import * as yup from "yup";
import i18next from "i18next";



export const validationSchema = yup.object().shape({
  last_name: yup.string().max(50).required("fieldRequired"),
  first_name: yup.string().max(50).required("fieldRequired"),
  mobile: yup
    .string()
    .when("select", (select, schema) => {
      if (select[0]?.value === "852") {
        return schema
          .required("*fieldRequired")
          .matches(/^[4-9][0-9]{7}$/, "fieldRequired")
          .length(8, "*fieldRequired");
      } else if (select[0]?.value === "853") {
        return schema
          .matches(/^[6][0-9]{7}$/, "fieldRequired")
          .length(8, "*fieldRequired")
          .required("*fieldRequired");
      } else if (select[0]?.value === "86") {
        return schema
          .matches(/^[1][0-9]{10}$/, "fieldRequired")
          .length(11, "fieldRequired")
          .required("fieldRequired");
      }
      return schema;
    })
    .required("fieldRequired"),
  email: yup.string().email("fieldRequired").max(100).required("fieldRequired"),
  eventName: yup.object().required("fieldRequired").test({
    name: "eventName",
    test: function (value) {
      const { value: locationValue, label: locationLabel } = value || {};

      return locationValue !== "" || locationLabel !== "";
    },
    message: "fieldRequired",
  }),
  eventLocation: yup.object().required("fieldRequired").test({
    name: "eventLocation",
    test: function (value) {
      const { value: locationValue, label: locationLabel } = value || {};

      return locationValue !== "" || locationLabel !== "";
    },
    message: "fieldRequired",
  }),
  eventDate: yup.object().required("fieldRequired").test({
    name: "eventDate",
    test: function (value) {
      const { value: locationValue, label: locationLabel } = value || {};

      return locationValue !== "" || locationLabel !== "";
    },
    message: "fieldRequired",
  }),
  eventTime: yup.object().required("fieldRequired").test({
    name: "eventTime",
    test: function (value) {
      const { value: locationValue, label: locationLabel } = value || {};

      return locationValue !== "" || locationLabel !== "";
    },
    message: "fieldRequired",
  }),
    tnc: yup.boolean().oneOf([true], "fieldRequired"),
});

